import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AppThemeProvider } from "./theme";
import { EarlyAccessProvider } from "./context/EarlyAccessContext";
import { AuthProvider } from "./context/AuthContext";
import { GlobalChatProvider } from "./context/GlobalChatContext";
import { NotesModalProvider } from "./context/NotesModalContext";
import { FocusTimerProvider } from "./context/FocusTimerContext";

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <AppThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <EarlyAccessProvider>
            <GlobalChatProvider>
              <FocusTimerProvider>
                <NotesModalProvider>
                  <App />
                </NotesModalProvider>
              </FocusTimerProvider>
            </GlobalChatProvider>
          </EarlyAccessProvider>
        </AuthProvider>
      </BrowserRouter>
    </AppThemeProvider>
  </React.StrictMode>
);
